import getSvgIcon from '../../../helpers/getSvgIcon';
import templates from '../templates';

class ActionColumns {
  #instance;

  init(instance) {
    this.#instance = instance;
    this.#setColumns();
  }

  #setColumns() {
    this.#instance.config.columns.push({
      name: 'buttons',
      align: 'center',
      label: `<div class='gantt_header_custom_grid tooltip-gantt ' data-key=${_('gantt_grid_burger_tooltip_text')}>
                <span class='gantt_header_custom_grid_icon color="#B2B2B2"'>${getSvgIcon('plus-1', 'regular', 24)}</span></div>`, // __("gantt_actions")
      task_types: 36, // ["project", "task", "milestone"],
      hide: false,
      resize: false,
      template: task => templates.getActionColumnTemplate('buttons', this.#instance, task),
    });
  }
}

export default new ActionColumns();
